// removed by extract-text-webpack-plugin
module.exports = {"academyHeader":"_9ulOQ","fixedTop":"_3MVMn","noBackground":"_L2dqg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/SnapaskHeader/SnapaskHeader.scss
// module id = 880
// module chunks = 9